export const lang = {
  newWardrobe: 'Novo Armário',
  newFolder: 'Nova Pasta',
  ocurrProblem: 'Ocorreu um problema',
  rename: 'Renomear',
  exclude: 'Excluir',
  objectRoles: 'Regras de objeto',
  accessRoles: 'Regras de acesso',
  systemRoles: 'Regras de sistema',
  properties: 'Propriedades',
  searchInFolder: 'Pesquisar na pasta',
  sign: 'Assinar',
  attribForm: 'Atribuir ficha',
  processOCR: 'Processar OCR',
  youCantPermissionViewForm: 'Você não possui permissão para visualizar esta ficha',
  details: 'Detalhes',
  form: 'Ficha',
  yes: 'Sim',
  not: 'Não',
  view: 'Visualizar',
  exportLabel: 'Exportar',
  copyTo: 'Copiar para',
  importTo: 'Importar para',
  print: 'Imprimir',
  editReplaceForm: 'Editar/Substituir ficha',
  printForm: 'Imprimir ficha',
  wardrobe: 'Armário',
  importLabel: 'Importar',
  name: 'Nome',
  createdIn: 'Criado em',
  rotate: 'Girar',
  attention: 'Atenção',
  pageCannotRotate: 'Esta página não pode ser rotacionado pois pertence a um documento com certificação digital',
  cannotPermission: 'Você não tem permissão para acessar este recurso',
  download: 'Download',
  move: 'Mover',
  deleteAnnotation: 'Excluir Anotação',
  questionDeleteAnnotation: 'Tem certeza que deseja excluir esta anotação?',
  cancel: 'Cancelar',
  insert: 'Inserir',
  processOCRWait: 'Processando OCR... aguarde',
  pageNotOCRProcessed: 'Esta página não possui OCR processado',
  process: 'Processar',
  save: 'Salvar',
  checkProcess: 'Verificar processamento',
  annotations: 'Anotações',
  ocr: 'OCR',
  files: 'Arquivos',
  search: 'Pesquisar',
  reports: 'Relatórios',
  settings: 'Configurações',
  page: 'Página',
  of: 'de',
  noRecordsFind: 'Nenhum registro localizado',
  recordsFind: 'registros encontrados',
  reportInfoSystem: 'Relatório informações do sistema',
  reportActivity: 'Relatório de atividades',
  reportError: 'Relatório de erros',
  volumes: 'Volumes',
  browserUnsupportCanvas: 'Seu browser não suporta canvas',
  formDocuments: 'Ficha/Documentos',
  usersOnline: 'Usuários conectados',
  lastDocsCreated: 'Documentos criados(últ. 24 horas)',
  lastPagesCreated: 'Páginas importadas(últ. 24 horas)',
  views: 'Visualizações',
  action: 'Ação',
  user: 'Usuário',
  users: 'Usuários',
  object: 'Objeto',
  sessionId: 'ID Sessão',
  date: 'Data',
  activityDetails: 'Detalhes da atividade',
  close: 'Fechar',
  application: 'Aplicação',
  uri: 'URI',
  errorDetails: 'Detalhes do erro',
  manageForms: 'Gerenciamento de fichas',
  manageImportPerfil: 'Gerenciamento de perfis importação',
  manageVolumes: 'Gerenciamento de volumes',
  manageGroups: 'Gerenciamento de grupos',
  manageUsers: 'Gerenciamento de usuarios',
  manageSystemRoles: 'Gerenciamento de regras sistema',
  manageObjectRoles: 'Gerenciamento de regras objetos',
  newForm: 'Nova ficha',
  editForm: 'Editar ficha',
  excludeForm: 'Excluir ficha',
  edit: 'Editar',
  newer: 'Novo',
  manageFields: 'Gerenciar campos',
  fields: 'Campos',
  field: 'Campo',
  newImportPerfil: 'Novo perfil de importação',
  limit: 'Limite',
  subGroup: 'Sub-grupos',
  newVolume: 'Novo volume',
  newGroup: 'Novo grupo',
  newUser: 'Novo usuário',
  newSystemRole: 'Nova regra de sistema',
  newObjectRole: 'Nova regra de objeto',
  renameFolder: 'Renomear pasta',
  propertiesFolder: 'Propriedades da pasta',
  propertiesDocument: 'Propriedades do documento',
  exportDocument: 'Exportar documento',
  excludeFolder: 'Excluir pasta',
  attribFormFolder: 'Atribuir ficha à pasta',
  excludeFolderMessage: 'Tem certeza que deseja excluir esta pasta?<br><br><b>Atenção.</b> Todas as páginas de todos os documentos contidos nesta pasta e sub-pastas serão <b>fisicamente excluídas</b>.<br><br>Obs. Esta operação pode levar vários minutos.',
  processOCRFolderMessage: 'Documentos da pasta enviados para processamento de OCR',
  processOCRDocumentMessage: 'Documento enviado para processamento de OCR',
  browserNotSupported: 'Navegador nao suportado',
  javascriptOutofdate: 'Javascript desatualizado',
  certificates: 'Certificados',
  select: 'Selecione',
  signFolder: 'Assinar Pasta',
  status: 'Status',
  searchDocument: 'Buscando documento',
  searchDocuments: 'Buscando documentos',
  documentsSuitableSign: 'documentos aptos para assinatura',
  documentSuitableSign: 'Documento apto para assinatura',
  signingDocument: 'Assinando documento',
  signCompleted: 'Assinatura concluída',
  folderNotContainsPageSuitableSign: 'Esta pasta não possui documentos aptos para assinatura',
  insertAnnotation: 'Inserir anotação',
  documentImportStepOne: 'Importar documentos (passo 1 de 3)',
  documentImportStepTwo: 'Importar documentos (passo 2 de 3)',
  documentImportStepThree: 'Importar documentos (passo 3 de 3)',
  renameDocument: 'Renomear documento',
  excludeDocument: 'Excluir documento',
  excludeDocumentMessage: 'Tem certeza que deseja excluir este documento?<br><br><b>Atenção.</b> Todas as páginas deste documento serão <b>fisicamente excluídas</b>.',
  documentAlredySentProcessOCR: 'Este documento já foi enviado para processamento de OCR',
  excludeFormMessage: 'Tem certeza que deseja excluir esta Ficha?<br><br><b>Atençao!!</b> A ficha não pode conter documentos',
  newField: 'Novo campo',
  editField: 'Editar campo',
  removeField: 'Excluir campo',
  excludeFieldMessage: 'Tem certeza que deseja excluir este campo?',
  type: 'Tipo',
  mask: 'Mascara',
  order: 'Ordem',
  required: 'Obrigatório',
  min: 'Min',
  max: 'Max',
  integer: 'Inteiro',
  text: 'Texto',
  cpf: 'CPF',
  cnpj: 'CNPJ',
  email: 'E-mail',
  trueFalse: 'Verdadeiro/Falso',
  selectOption: 'Seleção Opção',
  selectMultiple: 'Seleção Multipla',
  decimal: 'Decimal',
  keyword: 'Palavra-chave',
  editGroup: 'Editar Grupo',
  removeGroup: 'Excluir Grupo',
  excludeGroupMessage: 'Tem certeza que deseja excluir este Grupo?<br><br><b>Atençao!!</b> Todos os Usuários e SubGrupos deste Grupo serão excluidos',
  usersOfGroup: 'Usuários do Grupo',
  subgroupsOfGroup: 'SubGrupos do Grupo',
  editObjectRole: 'Editar Regra de Objeto',
  removeObjectRole: 'Excluir Regra de Objeto',
  excludeObjectRole: 'Tem certeza que deseja excluir esta Regra de objeto',
  movePage: 'Mover Página',
  excludePage: 'Excluir Página',
  excludePageMessage: 'Tem certeza que deseja excluir esta página?',
  newPerfil: 'Novo perfil',
  editPerfil: 'Editar perfil',
  excludePerfil: 'Excluir Perfil',
  excludePerfilMessage: 'Tem certeza que deseja excluir este Perfil?',
  editSystemRole: 'Editar Regra de Sistema',
  excludeSystemRole: 'Excluir Regra de Sistema',
  excludeSystemRoleMessage: 'Tem certeza que deseja excluir esta Regra de sistema?',
  editUser: 'Editar Usuário',
  excludeUser: 'Excluir Usuário',
  excludeUserMessage: 'Tem certeza que deseja excluir este Usuário?',
  editVolume: 'Editar Volume',
  excludeVolume: 'Excluir Volume',
  excludeVolumeMessage: 'Tem certeza que deseja excluir este Volume?<br><br><b>Atençao!!</b> O Volume não pode conter Páginas!',
  renameWardrobe: 'Renomear armário',
  excludeWardrobe: 'Excluir armário',
  excludeWardrobeMessage: 'Tem certeza que deseja excluir esta armário?<br><br><b>Atenção.</b> Todas as páginas de todos os documentos contidos neste armário e sub-pastas serão <b>fisicamente excluídas</b>',
  propertiesWardrobe: 'Propriedades do armário',
  editDataSuccess: 'Dados editados com sucesso',
  attribData: 'Atribuir dados',
  applyDataSuccess: 'Dados aplicados aos documentos com sucesso',
  selectRoleBeforeRemove: 'Selecione a regra e depois clique em excluir',
  roleCannotBeRemovedBecauseAction: 'Esta regra de acesso não pode ser removida pois está incluida na regra de ações',
  fileTypeCannotView: 'Este tipo de arquivo não pode ser visualizado no browser',
  documentCreatedSuccess: 'Documento criado com sucesso',
  documentCreatedError: 'Erro na criação do documento',
  processCompletedSuccess: 'Processo concluído com sucesso',
  processCompletedError: 'Processo concluído com erros',
  documentTypeCannotPrint: 'Este tipo de documento não pode ser impresso',
  providerRequiredMsg: 'O Campo provedor é obrigatório',
  limitCannotLessActual: 'Limite não pode ser menor que o tamanho atual',
  systemPermissions: 'Permissões de sistema',
  filesPermissions: 'Permissões de pastas/documentos',
  tipoNomeDocumentoRequired: 'O Valor para o nome do documento é obrigatório.',
  permissions: 'Permissões',
  folder: 'Pasta',
  group: 'Grupo',
  acaoDocumentosMesmoNomeRequired: 'O campo ação documento com mesmo nome é obrigatório.',
  tipoCampoRequired: 'Selecione o tipo do campo',
  document: 'Documento',
  documentWithoutPages: 'Este documento não possui páginas',
  replace: 'Substituir',
  pageCannotMovedOnlyPage: 'Este documento possui somente uma página',
  addPagesStartDocument: 'Adicionar páginas ao início do documento',
  addPagesEndDocument: 'Adicionar páginas ao final do documento',
  all: 'Todos',
  documentCreateImportPerfilFieldNullException: 'O perfil de importação exige um campo da ficha cujo valor não foi informado',
  manageConnections: 'Gerenciamento de conexões',
  fonteDadosRequired: 'O campo fonte de dados é obrigatório.',
  newConnection: 'Nova conexão',
  editConnection: 'Editar conexão',
  excludeConnection: 'Excluir conexão',
  excludeConnectionMessage: 'Tem certeza que deseja excluir esta conexão?<br><br><b>Atençao!!</b> A conexão não pode estar associada a nenhuma query',
  newQuery: 'Nova query',
  manageQuerys: 'Gerenciamento de query\'s',
  editQuery: 'Editar query',
  excludeQuery: 'Excluir query',
  excludeQueryMessage: 'Tem certeza que deseja excluir esta query?<br><br><b>Atençao!!</b> A query não pode estar associada a nenhuma integração',
  conexaoIdRequired: 'O campo conexão é obrigatório.',
  newIntegration: 'Nova integração',
  manageIntegrations: 'Gerenciamento de integrações',
  editIntegration: 'Editar integração',
  excludeIntegration: 'Excluir integração',
  excludeIntegrationMessage: 'Tem certeza que deseja excluir esta integração?<br><br><b>Atençao!!</b> A integração não pode estar associada a nenhum campo',
  activeIntegrations: 'Ativar integração',
  removeIntegrations: 'Remover integração',
  printReport: 'Imprimir relatório',
  clearRegs: 'Limpar registros',
  dateHour: 'Data/Hora',
  cannotOCRLicensed: 'OCR não licenciado',
  indexer: 'Indexador',
  changeForm: 'Alterar Ficha?',
  changeFormMessage: 'Alterar Ficha? Existem paginas ja indexadas e está alteração irá limpar todos os dados das paginas!',
  change: 'Alterar',
  selectVolumeMessage: 'Por favor, selecione um volume',
  selectImportPerfilMessage: 'Por favor, selecione um perfil de importação!',
  importation: 'Importação',
  executeUploadData: 'Executando upload dos dados',
  endUploadData: 'Upload dos dados concluído',
  executeUploadFiles: 'Executando upload dos arquivos',
  endUploadFiles: 'Upload dos arquivos concluído',
  executeImportLote: 'Executando importação do lote',
  endImportLote: 'Importação do lote concluído',
  updatePassword: 'Alterar senha',
  logout: 'Sair',
  updateUserPerfil: 'Alterar perfil usuário',
  configIndexDesktop: 'Configurar indexador desktop',
  create: 'Criar',
  manageAuthApplication: 'Gerenciamento de aplicações',
  newAuthApplication: 'Nova Aplicação',
  editAuthApplication: 'Editar Aplicação',
  removeAuthApplication: 'Excluir Aplicação',
  excludeAuthApplication: 'Tem certeza que deseja excluir esta Aplicação?',
  editConfigLiquidSuite: 'Editar configuração do Liquid Suite',
  manageLiquidSuite: 'Gerenciamento do liquid suite',
  resetPassword: 'Resetar a senha',
  resetPasswordMessage: 'Tem certeza que deseja resetar a senha deste Usuário?',
  reset: 'Resetar',
  resetPasswordSucces: 'Senha resetada com sucesso',
  fileNotFoundStorage: 'Arquivo não localizado no volume',
  password: 'Senha',
  userCreatedSuccess: 'Usuário criado com sucesso',
  userCreate: 'Criar usuário',
  valueNotIsNumber: 'O valor deve ser um numero inteiro',
  copy: 'Copiar',
  moveTo: 'Mover para',
  addMark: 'Adicionar marcação',
  removeMark: 'Remover marcação',
  addMarkQuestion: 'Adicionar esta marcação?',
  removeMarkQuestion: 'Remover esta marcação?',
  remove: 'Remover',
  viewWithoutMark: 'Visualizar sem marcações',
  viewWithMark: 'Visualizar com marcações',
  temporality: 'Temporalidade',
  totalDaysGreatThanZero: 'O total de dias deve ser maior que zero',
  notifyDaysGreatThanZero: 'Os dias de antecedencia deve ser maior que zero',
  almostOneEmail: 'Deve ter pelo menos 1 email para notificação',
  expired: 'Expirado',
  results: 'Resultados',
  signDocument: 'Assinar documento',
  signCompleteSuccess: 'Assinatura concluída com sucesso',
  documentNotSigned: 'Este Documento não está Assinado',
  componentNotInstaled: 'Componente não instalado!',
  componentNotInstaledMessage: 'O componente utilizado para assinatura digital não esta instalado!<br>Ao clicar em instalar, você será redirecionado para a página de instalação e após concluído voltara automaticamente para o Liquid Suite.',
  install: 'Instalar',
  errorWebPKI: 'Erro no componente WebPKI: ',
  deleteSign: 'Excluir assinatura?',
  deleteSignMessage: 'Tem certeza que deseja excluir essa assinatura?',
  manageWaterMark: 'Gerenciamento de marca dagua',
  newWaterMark: 'Nova Marca Dagua',
  editWaterMark: 'Editar Marca Dagua',
  waterMark: 'Marca Dagua',
  applyWaterMark: 'Aplicar Marca Dagua',
  apply: 'Aplicar',
  expiresIn: 'Expira em',
  manageActiveSessions: 'Gerenciamento de sessões',
  activeSessions: 'Sessões ativas',
  closeSession: 'Encerrar sessão',
  session: 'Sessão',
  closeSessionMessage: 'Deseja encerrar esta sessão? <br><b>ANTEÇÃO!!</b> Ao encerrar esta sessão, qualquer atividade em andamento desta sessão de usuário sera bloqueada.',
  toClose: 'Encerrar',
  manageTemporality: 'Gerenciamento de temporalidade',
  start: 'Iniciar',
  stop: 'Parar',
  temporalityService: 'Serviço de Temporalidade',
  excludeWatermark: 'Excluir Marca Dagua',
  excludeWatermarkMessage: 'Tem certeza que deseja excluir esta Marca Dagua?',
  rotateWithMarkMessage: '<b>ATENÇÃO!!</b> Esta página possui marcações. Ao rotacionar, todas as marcações serão removidas. Deseja continuar?',
  cannotPermissionAction: 'Você não tem permissão para executar esta ação!',
  mediaNotSupported: 'Arquivo de media não encontrado/suportado',
  mediaNotDecode: 'Arquivo de media sem decoder',
  exportAllResult: 'Exportar todos os resultados',
  exportFileSizeException: 'Para exportar estes arquivos, entre em contato com o suporte da Rede & Imagem.',
  exportTimeMessage: 'Atenção!! Este processo pode demorar alguns minutos. Por Favor, aguarde!',
  newNameDocment: ' ****NOVO****',
  copyToNewDocument: 'Copiar para novo documento',
  moveToNewDocument: 'Mover para novo documento',
  copyToDocument: 'Copiar para documento',
  moveToDocument: 'Mover para documento',
  selectAtLeastOnePage: 'Selecione pelo menos uma página!',
  classifyPages: 'Classificar páginas do documento',
  classify: 'Classificar',
  pagesCannotBeConvert: 'Existem páginas que não podem ser convertidas para PDF',
  exportSizeLimit: 'Os arquivos selecionados para exportação são maiores que 500 MB',
  historic: 'Histórico',
  toShare: 'Compartilhar',
  copyLinkMessage: 'Link copiado para a área de transferência',
  signPage: 'Assinando página',
  processDocument: 'Processando Documento',
  newMessage: 'Nova mensagem',
  send: 'Enviar',
  clean: 'Limpar',
  neww: 'Nova',
  folderSendToRemove: 'Pasta enviada para exclusão',
  folderSuccessRemove: 'Pasta excluída com sucesso',
  ocrAllWordsException: 'Neste modo de pesquisa, todas as palavras devem ter mais de 2 letras!',
  ocrAnyWordsException: 'Neste modo de pesquisa, pelo menos uma palavra deve ter mais de 2 letras!',
  wardrobeSendToRemove: 'Armário enviado para exclusão',
  wardrobeSuccessRemove: 'Armário excluído com sucesso',
  used: 'Utilizado',
  trash: 'Lixeira',
  help: 'Ajuda',
  processOCRFolderQuestion: '<b>ATENÇÃO!!</b> Somente os 5 primeiros documentos contidos nesta pasta (não incluido as sub-pastas) serão processados o OCR.<br>O processamento do OCR em lote de documentos deve ser solicitado junto ao Suporte da Rede & Imagem.',
  waiting: 'Aguardando',
  partialProcessed: 'Parcialmente processado',
  finished: 'Finalizado',
  canceled: 'Cancelado',
  confirm: 'Confirmar',
  ocrDetailsTitle: 'Detalhes agendamento/processamento OCR',
  ocrDetailsCancelButton: 'Cancelar processamento/agendamento',
  ocrCancelTitle: 'Cancelar Agendamento OCR',
  ocrCancelMessage: '<b>ATENÇÃO!!</b> Deseja cancelar este agendamento/processamento de OCR?',
  excluded: 'Excluído',
  monitor: 'Monitoramento',
  unlockDocs: 'Desbloquear documentos',
  unlockDocsMessage: 'Tem certeza que deseja desbloquear os documentos desta pasta e sub-pastas?',
  unlock: 'Desbloquear',
  unlockDocsSuccessMessage: 'Documents desbloqueados com sucesso!',
  rootFolder: 'Pasta raiz',
  setDefault: 'Definir como Padrão',
  update: 'Atualizar',
  unauthorized: 'Sua sessão não é mais válida! Entre novamente no Liquid Suite ou atualize a pagina no seu navegador!',
  manageQuerysAPI: 'Gerenciamento de query\'s API',
  newQueryAPI: 'Nova query API',
  editQueryAPI: 'Editar query API',
  excludeQueryAPI: 'Excluir query API',
  excludeQueryAPIMessage: 'Tem certeza que deseja excluir esta query API?<br><br><b>Atençao!!</b> A query API não pode estar associada a nenhuma integração API',

  newIntegrationAPI: 'Nova integração API',
  manageIntegrationsAPI: 'Gerenciamento de integrações API',
  editIntegrationAPI: 'Editar integração API',
  excludeIntegrationAPI: 'Excluir integração API',
  excludeIntegrationMessageAPI: 'Tem certeza que deseja excluir esta integração API?<br><br><b>Atençao!!</b> A integração não pode estar associada a nenhum campo',
  tokenExpired: 'Token expirado e/ou inválido',
};
